import React, { memo, useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import { useLangFile } from '../../context/LanguageContext';
import LayerStatisticsDataTable from './LayerStatisticsDataTable';
import LayerStatisticsBarChart from './BarChart/LayerStatisticsBarChart';
import {
  statisticsDataColumns,
  statisticsDataRows,
  statisticsOverviewColumns,
  statisticsOverviewRows,
} from './LayerStatisticsUtils';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { ToggleButton } from '@mui/material';
import { BarChart, ViewList } from '@mui/icons-material';
import type { LayerStatisticsData } from './sources/LayerStatisticsSourceTypes';

const ViewTypes = {
  TABLE: 'TABLE',
  HISTOGRAM: 'HISTOGRAM',
};

import Styles from './LayerStatistics.module.less';

type LayerStatisticsProps = {
  data: LayerStatisticsData;
  width: number;
};

const LayerStatistics = ({ data, width }: LayerStatisticsProps) => {
  const LangFile = useLangFile();
  const [viewType, setViewType] = useState(ViewTypes.HISTOGRAM);

  const onViewTypeChanged = useCallback(
    (event: unknown, value: string | null) => {
      if (value) {
        setViewType(value);
      }
    },
    [viewType]
  );

  if (data.items.length > 0) {
    return (
      <Box>
        <Box
          sx={{
            px: 1,
            pb: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h4>{LangFile.SurveyStatistics.statistics}</h4>

            <ToggleButtonGroup
              size="small"
              value={viewType}
              exclusive
              onChange={onViewTypeChanged}
              className={Styles.ButtonGroup}
            >
              <ToggleButton value={ViewTypes.HISTOGRAM}>
                <BarChart style={{ transform: 'rotate(90deg)' }} fontSize={'small'} />
              </ToggleButton>
              <ToggleButton value={ViewTypes.TABLE}>
                <ViewList fontSize={'small'} />
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Box>
            <LayerStatisticsDataTable
              columns={statisticsOverviewColumns(LangFile)}
              items={statisticsOverviewRows([data.min, data.mean, data.max])}
            />
          </Box>

          {viewType === ViewTypes.TABLE && (
            <LayerStatisticsDataTable
              columns={statisticsDataColumns(LangFile)}
              items={statisticsDataRows(data.items)}
            />
          )}

          {viewType === ViewTypes.HISTOGRAM && (
            <LayerStatisticsBarChart items={data.items} width={width} />
          )}
        </Box>
      </Box>
    );
  }
  return null;
};

export default memo(LayerStatistics);
